// @flow

import React, { Fragment } from 'react';
import { Col } from 'clark-styles';
import { CenteredCol, Offset, SmallHide, SmallOnly, TableHeader } from 'styles/table';

const Header = () => (
  <Fragment>
    <SmallOnly>
      <TableHeader>
        <Col sm={7} md={7} lg={3}>
          <Offset>DATE</Offset>
        </Col>
        <CenteredCol sm={3} md={3} lg={3}>
          REPORT
        </CenteredCol>
      </TableHeader>
    </SmallOnly>
    <SmallHide>
      <TableHeader>
        <Col sm={3} md={3} lg={3}>
          <Offset>DATE</Offset>
        </Col>
        <Col sm={2} md={2} lg={2}>
          STUDENT
        </Col>
        <Col sm={2} md={2} lg={2}>
          SUBJECT
        </Col>
        <Col sm={2} md={2} lg={2}>
          EARNINGS
        </Col>
        <CenteredCol sm={2} md={2} lg={2}>
          REPORT
        </CenteredCol>
      </TableHeader>
    </SmallHide>
  </Fragment>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/sessions/list/past/table-header/index.js